import { useQuery } from "@tanstack/react-query";
import { getSchool } from "../../api/apiSchools";
import i18next from "i18next";

export function useGetSchool(id) {
    const { isLoading, data: school, error } = useQuery({
        queryKey: ["schools", id, i18next.language],
        queryFn: () => getSchool(id),
        enabled: !!id,
        retry: false,
    });

    return { isLoading, error, school };
}
